"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AsyncState;
(function (AsyncState) {
    AsyncState["initializing"] = "initializing";
    AsyncState["loading"] = "loading";
    AsyncState["loaded"] = "loaded";
    AsyncState["updating"] = "updating";
    AsyncState["updated"] = "updated";
    AsyncState["deleting"] = "deleting";
    AsyncState["deleted"] = "deleted";
    AsyncState["inserting"] = "inserting";
    AsyncState["inserted"] = "inserted";
    AsyncState["empty"] = "empty";
    AsyncState["error"] = "error";
})(AsyncState = exports.AsyncState || (exports.AsyncState = {}));
//# sourceMappingURL=component.types.js.map